// components/SectionDivider.js
import React from 'react';

const SectionDivider = ({ title }) => (
  <div className="d-flex align-items-center my-4">
    <h3 className="mb-0 me-3 text-primary">{title}</h3>
    <div className="flex-grow-1 border-bottom border-2 border-light"></div>
  </div>
);

export default SectionDivider;
